module.exports = __webpack_public_path__ + "static/media/pinterest.2e4b6bd1.svg";